import { Type } from "class-transformer";

export class IncidentItem {
    lessonId = 0;
    @Type(() => Date)
    date: Date;
    hour = 0;
    domain = "";
    courseId = 0;
    incidents = "";

    constructor(lessonId: number, date: Date, hour: number, domain: string, courseId: number, incidents: string) {
        this.lessonId = lessonId;
        this.date = date;
        this.hour = hour;
        this.domain = domain;
        this.courseId = courseId;
        this.incidents = incidents;
    }
}
